const SuccessMsg = ({}) => (
  <div>
    <div className="tw-text-center tw-text-gray-75 tw-border-solid tw-bg-[#F7F9FC] tw-border-neutral-gray-10 tw-w-[552px] tw-mt-[24px] !tw-p-[36px] tw-border tw-rounded-[12px]">
      <div className="tw-text-18px tw-leading-[24px] tw-font-bold">
        Your request to open title has been received!
      </div>
      <div className="tw-text-14px tw-leading-[20px] tw-font-normal tw-pt-[20px]">
        Your application is currently under review and should be open within a few business hours.
      </div>
      <div className="tw-text-14px tw-leading-[20px] tw-font-normal tw-pt-[20px]">
        You can see more information about your transaction by visiting:{" "}
        <span
          className="tw-cursor-pointer tw-text-semantic-blue-110"
          onClick={() => window.open("https://app.blueprinttitle.com", "_blank")}
        >
          Blueprint Title Portal
        </span>
      </div>
    </div>
  </div>
);

export default SuccessMsg;
